import type { ReactNode } from "react";

import { SytoLogo } from "./ui/syto-logo";

type Props = {
  title?: string;
  children: ReactNode;
  /** When true (default), reserves bottom space for floating BottomNav. */
  withBottomNav?: boolean;
  /** Hide the logo header (used by screens with a TopBar instead). */
  hideHeader?: boolean;
};

// Graphite redesign shell. Per design_handoff/README §Screens, every screen
// is hosted in a flex-col scroll container with 22px horizontal padding,
// auth + entry screens omit the logo header (they have their own TopBar).
export function ScreenShell({ title, children, withBottomNav = false, hideHeader = false }: Props) {
  return (
    <main
      className="min-h-dvh flex flex-col safe-top safe-bottom"
      style={{ background: "var(--bg)", color: "var(--ink)" }}
    >
      <div
        className="w-full mx-auto flex flex-col gap-4"
        style={{
          maxWidth: 480,
          padding: withBottomNav ? "12px 22px 120px" : "12px 22px 32px",
          minHeight: "100dvh",
        }}
      >
        {!hideHeader ? (
          <header className="flex items-center justify-between" style={{ marginBottom: 6 }}>
            <SytoLogo size={20} />
            {title ? (
              <span
                className="uppercase"
                style={{
                  fontFamily: "var(--font-mono)",
                  fontSize: 10,
                  letterSpacing: "0.12em",
                  color: "var(--muted)",
                  fontWeight: 600,
                }}
              >
                {title}
              </span>
            ) : null}
          </header>
        ) : null}
        {children}
      </div>
    </main>
  );
}
